import React from 'react';
import { TableRow, TableCell, Skeleton } from '@mui/material';

interface TableSkeletonProps {
  rows?: number;
  columns?: number;
}

type ColConfig = {
  key: string;
  variant: 'circular' | 'text';
  width: number | string;
  height: number;
  borderRadius: string;
};

function buildColConfigs(columns: number): ColConfig[] {
  const configs: ColConfig[] = [];
  for (let j = 0; j < columns; j++) {
    let width: number | string;
    if (j === 0) {
      width = 32;
    } else if (j === 2) {
      width = '150px';
    } else {
      width = '80px';
    }
    configs.push({
      key: `skeleton-col-${j}`,
      variant: j === 0 ? 'circular' : 'text',
      width,
      height: j === 0 ? 32 : 20,
      borderRadius: j === 0 ? '50%' : '4px',
    });
  }
  return configs;
}

export const TableSkeleton = ({
  rows = 10,
  columns = 10,
}: TableSkeletonProps) => {
  const rowKeys: string[] = [];
  for (let i = 0; i < rows; i++) {
    rowKeys.push(`skeleton-row-${i}`);
  }
  const colConfigs = buildColConfigs(columns);
  return (
    <>
      {rowKeys.map((rowKey) => (
        <TableRow key={rowKey}>
          {colConfigs.map(({ key, variant, width, height, borderRadius }) => (
            <TableCell
              key={`${rowKey}-${key}`}
              sx={{
                borderBottom: 'none',
                py: 2,
                px: 1,
              }}
            >
              <Skeleton
                variant={variant}
                width={width}
                height={height}
                sx={{
                  bgcolor: 'rgba(255, 255, 255, 0.05)',
                  borderRadius,
                }}
              />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
};
